// The deterministic safety tables, read-only (owner 2026-10-14: "we need to be able to
// view the safety tables or interactions outside of the code"). They are authored in
// code and change by PR; the console shows them, with the source each row cites.

export type InteractionRow = {
  a: string;
  b: string;
  a_kind?: string | null;
  b_kind?: string | null;
  severity: 'avoid' | 'caution' | string;
  mechanism?: string | null;
  action?: string | null;
  user_line?: string | null;
  citation?: string | null;
};

export type SafetyTablesResponse = {
  interactions: InteractionRow[];
  /** where a run reads the interaction rows from (the Safety Index registry, or the constant) */
  interactions_source?: string;
  /** pairs NatMed rates below caution: a note on the active row, never a hold */
  class_notes?: { a: string; b: string; note: string; citation?: string | null }[];
  medication_classes: {
    source?: string;
    version?: number;
    /** class -> who ratified it, when, and its scope */
    ratified: Record<string, { by?: string; on?: string; scope?: string }>;
    /** medicine name (generic or brand) -> its classes (fluoxetine: ssri AND cyp2d6 inhibitor) */
    members: Record<string, string[]>;
  };
  /** an allergy that adds a note (not a hold) to these supplements, in the owner's copy */
  allergen_cautions?: { allergen: string; compounds: string[]; copy?: string | null }[];
  /** the source a dict-table row cites, per (table, key, term); absent = "No source recorded" */
  citations?: { table: string; key: string; term: string; citation: string }[];
  /** a CONDITION that holds an allergy's foods (coeliac disease -> gluten) */
  condition_food_keys?: Record<string, string>;
  allergen_compounds: Record<string, string[]>;
  allergen_synonyms: Record<string, string[]>;
  stated_other_source: { allergen: string; term: string | null; sources: string[] }[];
  condition_contraindications: Record<string, string[]>;
  not_the_same_compound: Record<string, string[]>;
  allergen_foods: Record<string, string[]>;
  food_stated_safe: { allergen: string; term: string; words: string[] }[];
  non_food_allergies: string[];
};

export const SEVERITY_HEX: Record<string, string> = { avoid: '#F2635A', caution: '#F2A93B' };

export const KIND_LABEL: Record<string, string> = {
  compound: 'supplement',
  medication: 'medicine',
  medication_class: 'medicine class',
};
